/* BjerveUr: footer accordions (spec 45.3).
   The footer block <details> render closed (mobile-first). On desktop they
   are forced open so the footer keeps its columns; on mobile they behave as
   accordions. Summaries are removed from the tab order on desktop where they
   are inert. */
(function () {
  var accordions = document.querySelectorAll('.footer-block__details');
  if (!accordions.length) return;
  var desktop = window.matchMedia('(min-width: 750px)');

  function sync() {
    accordions.forEach(function (details) {
      if (desktop.matches) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
      var summary = details.querySelector('summary');
      if (summary) summary.tabIndex = desktop.matches ? -1 : 0;
    });
  }

  sync();
  desktop.addEventListener('change', sync);

  accordions.forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (desktop.matches && !details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });
  });
})();
